import React, { Component } from 'react';
import './styles.css';
import { titleHead } from './../../../services/helper'

class Page403 extends Component {
    componentDidMount() {
        titleHead('403')
    }
    
    render() {
        return (
            <div className="app flex-row align-items-center" style={{ "justifyContent": "center", textAlign: 'center', marginTop: '100px' }}>
                <div>
                    <h1 className="float-left display-3 mr-4" style={{ fontSize: '40px' }}>403</h1>
                    <h4 className="pt-3" style={{ fontSize: '17px' }}>Oops! You don't have permission.</h4>
                    <p className="text-muted float-left">Please contact to administrator.</p>
                </div>
            </div>
        );
    }
}

export default Page403;


// WEBPACK FOOTER //
// ./src/containers/exception/403/index.js